module.exports = __webpack_public_path__ + "media/images/players/WATSON_BUBBA-28eba1ff8defa5621b6b77743fc69cb9.png";